import { etudiantsConstants as etds } from "../../../constants/etudiants";

const initialState = { loading: true, list: [], data: null, releveCompte: [] };

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case etds.GET_ETUDIANTS:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case etds.GET_ETUDIANT:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case etds.GET_RELEVE:
      return {
        ...state,
        loading: false,
        releveCompte: payload,
      };
    default:
      return state;
  }
}
